module.exports = __webpack_public_path__ + "static/BrandonGrotesque-RegularItalic-386950f8b1420219575e18392aa8a421.ttf";